

















































import ajax from '@/lib/ajax';
import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import CampaignDetails from '@/components/Campaigns/CampaignDetails.vue';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue'
import CampaignStatus from '@/components/Campaigns/Display/CampaignStatus.vue';
import CampaignStatusSet from '@/components/Campaigns/CampaignStatusSet.vue';
import CampaignStatusEnum from '@/models/Campaigns/CampaignStatus';
import CampaignDto from '@/models/Campaigns/CampaignDto';
import EntityType from '@/models/Shared/EntityType';
import Notes from '@/components/Notes/Notes.vue';
import Documents from '@/components/Documents/Documents.vue';
import CampaignContactsTab from '@/components/CampaignContacts/CampaignContactsTab.vue';
import CampaignOpportunitiesTab from '@/components/CampaignOpportunities/CampaignOpportunitiesTab.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'Campaign',
  components: { Alert, CampaignStatus, CampaignStatusSet, CampaignDetails, CampaignContactsTab, CampaignOpportunitiesTab, Documents, Notes }})

export default class extends GiganautVue {

  campaignStatusEnum = CampaignStatusEnum;
  entityType = EntityType.Campaign;

  async beforeMount() {
    await CampaignDetailsModule.getCampaign(this.$route.params.campaignid);
  }

  get currentCampaign() {
    return CampaignDetailsModule.currentCampaign;
  }

  get loading() {
    return CampaignDetailsModule.loading;
  }

  async sendEmailCampaign() {
		const options: VuetifyConfirmObject = {
            buttonTrueText: "SEND",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('This will send the email to all contacts in the audience list. Would you like to send?', options);
        if (result) {
			await CampaignDetailsModule.sendEmailCampaign();
        }

	}
}
